export default __webpack_public_path__ + "static/media/rightGreyArrow.f94d7b3d.svg";